module.exports = __webpack_public_path__ + "media/fonts/FiraSans-Regular-1c0bf0728b51cb9f2ddc01b897da06d3.ttf";